var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("h1", { staticClass: "mt-2 mb-4 font-sans-bold" }, [
      _vm._v(_vm._s(_vm.event.title)),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "mb-4" }, [
      _c("strong", [_vm._v("Status:")]),
      _vm._v(" "),
      _vm.event.published
        ? _c("span", [_vm._v("Published")])
        : _c(
            "span",
            [
              _vm.event.status === "new" ? [_vm._v("Draft")] : _vm._e(),
              _vm._v(" "),
              _vm.event.status === "needs review"
                ? [_vm._v("In Review")]
                : _vm._e(),
            ],
            2
          ),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "mb-4" }, [
      _c("strong", [_vm._v("Festival:")]),
      _vm._v(
        " " +
          _vm._s(_vm.event.festival ? _vm.event.festival.title : "") +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "mb-4" }, [
      _c("strong", [_vm._v("Start date:")]),
      _vm._v(
        " " +
          _vm._s(_vm._f("moment")(_vm.event.start_at, "MMM Do YYYY, h:mm a")) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "mb-4" }, [
      _c("strong", [_vm._v("End date:")]),
      _vm._v(
        " " +
          _vm._s(_vm._f("moment")(_vm.event.end_at, "MMM Do YYYY, h:mm a")) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "mb-4" }, [
      _c(
        "button",
        {
          staticClass: "bg-blue text-white rounded-sm p-2",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.editEvent.apply(null, arguments)
            },
          },
        },
        [_vm._v("Edit Event")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }